import { type MarketEnum, marketList } from '@hvf/contracts'
import type { Component } from 'solid-js'
import { useService } from 'solid-services'
import { useFilters } from '../state/filter'
import { FilterSelect } from './FilterSelect'

export const AssetType: Component = () => {
  const { filters, setAssetType } = useService(useFilters)()

  return (
    <FilterSelect
      label="Market"
      items={marketList}
      selected={filters().assetType}
      onChange={setAssetType}
    />
  )
}
